/* import __COLOCATED_TEMPLATE__ from './main.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import { and, not, readOnly, alias } from '@ember/object/computed';
import Component from '@ember/component';
import { inject as service } from '@ember/service';

export default Component.extend({
  store: service(),
  intercomEventService: service(),
  notificationsService: service(),

  zendeskUsername: alias('settings.username'),
  zendeskApiToken: alias('settings.apiToken'),
  zendeskAppName: alias('settings.zendeskAppName'),
  hasAllCredentials: and('zendeskUsername', 'zendeskApiToken', 'zendeskAppName'),

  doesNotHaveAllCredentials: not('hasAllCredentials'),
  isConnected: readOnly('settings.connected'),
});
